!(function () {
    function e() {
        document.body.addEventListener("keydown", function (e) {
            e.target, "Tab" === e.key && document.documentElement.classList.remove("no-focus-outline");
        });
    }
    "loading" !== document.readyState ? e() : document.addEventListener("DOMContentLoaded", e);
})();
const addresses = (function () {
        const z = "[data-address]",
            t = "[data-address-fields]",
            n = "[data-address-toggle]",
            o = "[data-address-form]",
            c = "[data-address-delete-form]";
        function r() {
            const r = document.querySelectorAll(z);
            r.length &&
                (Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                r.forEach((e) => {
                    !(function (e) {
                        e.querySelector(t);
                        const r = e.querySelector(o),
                            a = e.querySelector(c);
                        e.querySelectorAll(n).forEach((e) => {
                            e.addEventListener("click", () => {
                                r.classList.toggle("hide");
                                e.closest(z).classList.toggle("active")
                            });
                        });
                        const s = r.querySelector("form").id;
                        if (s && "address_form_new" !== s) {
                            const e = s.split("_").pop(),
                                t = "AddressCountry_" + e,
                                n = "AddressProvince_" + e,
                                o = "AddressProvinceContainer_" + e;
                            Shopify.CountryProvinceSelector && new Shopify.CountryProvinceSelector(t, n, { hideElement: o });
                        }
                        a &&
                            a.addEventListener("submit", (e) => {
                                const t = a.getAttribute("data-confirm-message");
                                window.confirm(t || "Are you sure you wish to delete this address?") || e.preventDefault();
                            });
                    })(e);
                }));
        }
        return "loading" !== document.readyState ? r() : document.addEventListener("DOMContentLoaded", r), { start: r };
    })(),
    anchorLinks = (function () {
        let e, t;
        function n() {
            (e = document.querySelector("header")), window.addEventListener("hashchange", o), location.hash && o();
        }
        function o(n) {
            t = e ? e.offsetHeight : 0;
            const o = location.hash.toString().replace("#/", "").replace("#", ""),
                c = document.querySelector('[name="' + o + '"]');
            c && function(e) {
                let n;
                const o = e ? e.offsetTop : 0,
                    c = window.pageYOffset,
                    r = o - t - c;
                window.requestAnimationFrame((function o(a) {
                    n || (n = a);
                    const s = a - n,
                        i = Math.min(s / 600, 1);
                    window.scrollTo(0, c + r * i), s < 600 ? window.requestAnimationFrame(o) : (history.replaceState("", document.title, window.location.pathname + window.location.search), setTimeout((function() {
                        const n = e ? e.offsetTop : 0;
                        window.scrollTo(0, n - t)
                    }), 250))
                }))
            }(c)
        }
        return "loading" !== document.readyState ? n() : document.addEventListener("DOMContentLoaded", n), {
            start: n
        }
    })();
! function() {
    let e, t, n = !1,
        o = 0;

    function c() {
        e = document.querySelector(".announcement-bar"), e && (e.addEventListener("mouseenter", a), e.addEventListener("mouseleave", r), t = e.querySelector(".announcement-bar__slider"), o = t.querySelectorAll(".announcement").length, r())
    }

    function r() {
        o > 1 && (n = setInterval(s, 5e3))
    }

    function a() {
        n && clearInterval(n)
    }

    function s() {
        t.style.transform = "translateY(-100%)", t.style.transitionDuration = "1s", setTimeout(i, 1e3)
    }

    function i() {
        const e = t.querySelector(".announcement");
        t.style.transitionDuration = "0s", e.remove(), t.style.transform = "translateY(0)", t.appendChild(e)
    }
    "loading" !== document.readyState ? c() : document.addEventListener("DOMContentLoaded", c)
}(),
function() {
    function e() {
        const e = document.querySelector("button.gwp--add");
        e && e.addEventListener("click", t)
    }

    function t(e) {
        e.target.disabled = !0;
        const t = document.querySelector(".template-cart"),
            n = new XMLHttpRequest;
        n.open("POST", "/cart/add.js", !0), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), n.onload = function() {
            if (this.status >= 200 && this.status < 400)
                if (t) window.location.reload();
                else try {
                    miniCart.refresh(e.target), miniCart.show(),
                        function() {
                            const e = document.querySelector(".cart-gwp");
                            e && e.remove()
                        }()
                } catch (e) {
                    window.location.reload()
                }
        }, n.send(`id=${e.target.dataset.variant}&quantity=1`)
    }
    "loading" !== document.readyState ? e() : document.addEventListener("DOMContentLoaded", e)
}();
const maxQTY = function() {
        let e, t, n, o, c, r = [],
            a = [];

        function s() {
            if (n = document.querySelector('input[name="checkout"]'), e = document.querySelector(".cart-items"), t = document.querySelector(".template-cart"), e && (o = e.querySelectorAll("[data-max-qty]"), c = document.querySelector(".cart-max-container"), o.length)) try {
                ! function() {
                    for (let e = 0, t = o.length; e < t; e++) {
                        const t = o[e],
                            n = t.getAttribute("data-product-id"),
                            c = t.getAttribute("data-product-title"),
                            s = t.getAttribute("data-max-qty"),
                            i = maxQtyLine.replace("{{ title }}", c).replace("{{ max }}", s);
                        r.includes(n) ? r.includes(n) && !a.includes(i) && a.push(i) : r.push(n)
                    }! function() {
                        if (a.length) {
                            n.disabled = !0,
                                function(e) {
                                    switch (maxQtyType) {
                                        case "modal":
                                            t ? modal.loadHTML(e) : i(e);
                                            break;
                                        default:
                                            i(e)
                                    }
                                }(`<div class="cart-max-error"><ul>${a.map((function(e){return`<li>${e}</li>`})).join("")}</ul>${maxQtyBase}</div>`)
                        } else c && (c.innerHTML = "")
                    }()
                }()
            } catch (e) {}
        }

        function i(e) {
            try {
                c.innerHTML = e
            } catch (e) {}
        }
        return "loading" !== document.readyState ? s() : document.addEventListener("DOMContentLoaded", s), {
            reload: s
        }
    }(),
    collapsable = function() {
        let e;

        function t() {
            e = document.querySelectorAll(".collapsable"), e.length && function() {
                for (let t = 0, o = e.length; t < o; t++) try {
                    e[t].querySelector(".toggle").addEventListener("click", n)
                } catch {}
            }()
        }

        function n(e) {
            try {
                e.preventDefault(), e.target.parentElement.classList.toggle("active")
            } catch {}
        }
        return "loading" !== document.readyState ? t() : document.addEventListener("DOMContentLoaded", t), {
            wrap: t
        }
    }(),
    collections = function() {
        let e, t, n, o, c, r, a, s = [],
            i = [],
            l = 0;

        function d() {
            document.querySelector(".template-collection") && function() {
                n = document.querySelector(".pagination");
                const i = document.querySelector('select[name="sort_by"]');
                i && i.addEventListener("change", y);
                e = document.querySelector(".collection-filters"), e && function() {
                    if (o = document.querySelectorAll(".collection-filters__block.toggle"), t = document.querySelector(".collection-filters__breadcrumbs"), c = document.querySelector(".collection-filters__trigger"), c && e) {
                        c.addEventListener("click", p);
                        const t = e.querySelectorAll(".toggle a");
                        t.length && function(e) {
                            for (let t = 0, n = e.length; t < n; t++) e[t].addEventListener("click", m)
                        }(t);
                        const n = e.querySelectorAll(".toggle .active");
                        n.length && function(e) {
                            for (let t = 0, n = e.length; t < n; t++) {
                                const n = e[t].dataset.cat;
                                s.indexOf(n) < 0 && s.push(n), e[t].closest(".collection-filters__block").classList.add("on")
                            }
                        }(n)
                    }
                }();
                a = document.querySelector(".collection-filters__block--size");
                const l = document.querySelectorAll(".collection-filters__block.toggle h5");
                if (l)
                    for (let e = 0, t = l.length; e < t; e++) l[e].addEventListener("click", g);
                if (r = document.querySelectorAll(".collection-settings__item"), r)
                    for (let e = 0, t = r.length; e < t; e++) r[e].addEventListener("click", h);
                u(), window.addEventListener("resize", u)
            }()
        }

        function u() {
            l !== window.innerWidth && (window.innerWidth < 1024 ? (e && e.classList.remove("on"), t && t.classList.remove("on"), n && n.classList.remove("on")) : e.classList.contains("sidebar") && (e && e.classList.add("on"), t && t.classList.add("on"), n && n.classList.add("on"))), l = window.innerWidth
        }

        function m(e) {
            e.preventDefault();
            const t = e.target.classList.contains("active") || e.target.parentElement.querySelector(".active");
            let n = e.target.closest("a").href;
            if (!t) {
                let t = "";
                for (let n = 0, c = o.length; n < c; n++) e.target.dataset.cat !== o[n].dataset.cat && (t += f(o[n]));
                n = `${n}${t}`
            }
            window.location = n
        }

        function f(e) {
            const t = e.querySelector(".active");
            if (t) {
                const e = t.dataset.tag;
                if (!i.includes(e)) return i.push(e), "+" + e
            }
            return ""
        }

        function p() {
            c.classList.toggle("open"), e && e.classList.toggle("on"), t && t.classList.toggle("on"), n && n.classList.toggle("on")
        }

        function g(e) {
            e.target.parentElement.classList.toggle("on")
        }

        function h(e) {
            for (let e = 0, t = r.length; e < t; e++) r[e].classList.remove("active");
            const t = document.querySelector(".collection-grid"),
                n = e.target.closest(".collection-settings__item");
            n.classList.add("active"), n.classList.contains("single") ? t.classList.add("single") : t.classList.remove("single")
        }

        function y(e) {
            const t = e.target.value ? "?sort_by=" + e.target.value : "";
            window.location.search = decodeURIComponent(t)
        }
        return "loading" !== document.readyState ? d() : document.addEventListener("DOMContentLoaded", d), {}
    }(),
    consent = function() {
        const e = document.querySelector(".consent-banner");
        let t, n;

        function o() {
            e && (t = e.querySelector(".consent-accept"), n = parseInt(e.dataset.length), function(e) {
                const t = e + "=",
                    n = top.document.cookie.split(";");
                for (let e = 0; e < n.length; e++) {
                    let o = n[e];
                    for (;
                        " " === o.charAt(0);) o = o.substring(1);
                    if (0 === o.indexOf(t)) return o.substring(t.length, o.length)
                }
                return !1
            }("acceptsConsent") ? e.remove() : (t.addEventListener("click", c), e.classList.add("on")))
        }

        function c() {
            ! function(e, t) {
                try {
                    const o = new Date;
                    o.setMonth(o.getMonth() + n), top.document.cookie = `${e}=${t}; expires=${o.toGMTString()} ;path=/`
                } catch (e) {}
            }("acceptsConsent", !0), e.remove()
        }
        return "loading" != document.readyState ? o() : document.addEventListener("DOMContentLoaded", o), {
            start: o
        }
    }(),
    discounts = function() {
        let e, t, n, o, c, r, a = sessionStorage.getItem("discount_code"),
            s = sessionStorage.getItem("discount_amount"),
            i = sessionStorage.getItem("discount_total"),
            l = sessionStorage.getItem("discount_items");

        function d() {
            e = document.querySelector(".cart-discount"), e && function() {
                t = e.querySelector(".btn"), n = e.querySelector("input"), o = e.querySelector(".cart-discount__error"), c = document.querySelector(".cart-subtotal__row--discounts"), r = document.querySelector(".cart-subtotal__row--totals"), a && f();
                t.addEventListener("click", u), n.addEventListener("keydown", (function(e) {
                    "Enter" === e.key && u(e)
                }))
            }(), void 0 !== window.Shopify.Checkout && "thank_you" === window.Shopify.Checkout.step && (sessionStorage.removeItem("discount_code"), sessionStorage.removeItem("discount_amount"), sessionStorage.removeItem("discount_items"), sessionStorage.removeItem("discount_total"))
        }

        function u(e) {
            e.preventDefault(), e.stopPropagation(), n.value ? (! function(e) {
                const t = new XMLHttpRequest;
                t.open("GET", `${window.location.origin}/discount/${e}`, !0), t.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), t.onload = function() {
                    m(!0)
                }, t.send()
            }(n.value.trim()), t.innerHTML = "Loading...", t.classList.add("disabled")) : g()
        }

        function m(e = !1) {
            if (a || e) {
                const e = new XMLHttpRequest;
                e.open("GET", window.location.origin + "/checkout", !0), e.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), e.onload = function() {
                    ! function(e) {
                        const o = document.createElement("div");
                        o.innerHTML = e;
                        const c = o.querySelector(".tags-list > .tag"),
                            r = !!c && c.querySelector(".reduction-code__text").innerText,
                            d = o.querySelector(".total-recap"),
                            u = o.querySelectorAll(".order-summary__section__content .product");
                        if (c && r.toUpperCase() === n.value.trim().toUpperCase()) try {
                            a = n.value.length ? n.value : a, sessionStorage.setItem("discount_code", a), s = function(e) {
                                    try {
                                        return e.querySelector("[data-checkout-discount-amount-target]").innerHTML.trim()
                                    } catch (t) {
                                        return function(e) {
                                            const t = e.querySelector(".total-recap__original-price").innerText.replace(/[^\w.]+/g, ""),
                                                n = e.querySelector(".total-recap__final-price").innerText.replace(/[^\w.]+/g, "");
                                            return "-$" + parseFloat(t - n).toFixed(2)
                                        }(e)
                                    }
                                }(d), sessionStorage.setItem("discount_amount", s), l = function(e) {
                                    const t = [];
                                    for (let n = 0, o = e.length; n < o; n++) {
                                        const o = e[n];
                                        if (o.querySelector(".reduction-code")) try {
                                            const e = o.querySelector(".product__price .order-summary__small-text").innerText.replace(/[^\w.]+/g, ""),
                                                n = o.querySelector(".product__price .order-summary__emphasis").innerText.replace(/[^\w.]+/g, "");
                                            t.push({
                                                id: o.getAttribute("data-variant-id"),
                                                discount: parseFloat(e) - parseFloat(n)
                                            })
                                        } catch (e) {}
                                    }
                                    return JSON.stringify(t)
                                }(u), sessionStorage.setItem("discount_items", l), i = d.querySelector("[data-checkout-payment-due-target]").innerHTML.trim(), sessionStorage.setItem("discount_total", i),
                                function() {
                                    const e = document.querySelectorAll(".cart-item__discount");
                                    for (let t = 0, n = e.length; t < n; t++) e[t].remove();
                                    const t = document.querySelectorAll('.cart-items__column[data-label="Total"]');
                                    for (let e = 0, n = t.length; e < n; e++) {
                                        const n = (parseFloat(t[e].getAttribute("data-total")) / 100).toFixed(2);
                                        t[e].innerHTML = "$" + n
                                    }
                                }(), f()
                        } catch (e) {} else g();
                        t && (t.innerHTML = t.dataset.default, t.classList.remove("disabled"))
                    }(this.response)
                }, e.send()
            }
        }

        function f() {
            o.innerHTML = "", o.classList.remove("on"), n.value = a;
            try {
                c.innerHTML = `<p>Discount (${a.trim()})</p><p class="cart-subtotal--price">${s}</p>`, r.innerHTML = `<p class="font--demi caps">Estimated Total</p><p class="cart-subtotal--price">${i}</p>`,
                    function() {
                        const e = JSON.parse(l),
                            t = document.querySelectorAll(".cart-items__row[data-variant-id]");
                        for (let n = 0, o = t.length; n < o; n++) {
                            const o = t[n],
                                c = e.filter((function(e) {
                                    return e.id === o.getAttribute("data-variant-id")
                                }));
                            c && c.length && p(o, c)
                        }
                    }()
            } catch (e) {}
        }

        function p(e, t) {
            const n = e.querySelector(".cart-item__remove"),
                o = e.querySelector(".cart-item__discount"),
                c = `<small class="cart-item__discount price--discount"><br>Discount (${a})</small>`;
            o ? o.innerHTML = c : n.insertAdjacentHTML("beforebegin", c);
            const r = e.querySelector('.cart-items__column[data-label="Total"]'),
                s = (parseFloat(r.getAttribute("data-total")) / 100).toFixed(2),
                i = `<span class="visually-hidden">Regular price</span>\n                         <s>$${s}</s><br>\n                         <span class="price--discount">$${(s-t[0].discount).toFixed(2)}</span>`;
            r.innerHTML = i
        }

        function g() {
            o && (o.innerHTML = "Please enter a valid discount code", o.classList.add("on"))
        }
        return "loading" !== document.readyState ? d() : document.addEventListener("DOMContentLoaded", d), {
            load: d,
            refresh: m
        }
    }(),
    dropdown = function() {
        function e() {
            const e = document.querySelectorAll("select");
            for (let n = 0, o = e.length; n < o; n++) {
                const o = e[n],
                    c = o.querySelectorAll("option").length,
                    r = o.closest(".select-wrapper"),
                    a = o.hasAttribute("class") && !o.classList.contains("option-chooser"),
                    s = void 0 !== o.dataset.nowrap;
                a || r || s || !c || t(o)
            }
        }

        function t(e) {
            const t = document.createElement("span");
            t.classList.add("select-wrapper"), e.parentNode.insertBefore(t, e), t.appendChild(e);
            const c = e.querySelectorAll("option"),
                r = 0 | e.selectedIndex;
            let a = `<span class="select_row">\n                        <span class="select__selected">${e.dataset.prefix?`<span class="desktop-only">${e.dataset.prefix}: </span>`:""}${c[r].innerText}</span>\n                        <span class="select__arrow">&lang;</span>\n                    </span>\n                    <ul class="select__options">`;
            for (let e = 0, t = c.length; e < t; e++) {
                const t = c[e];
                a += `<li data-val="${t.value}">${t.innerText}</li>`
            }
            a += "</ul>", e.insertAdjacentHTML("afterend", a),
                function(e) {
                    e.parentNode.addEventListener("click", n), e.parentNode.addEventListener("mouseleave", o)
                }(e),
                function(e) {
                    const t = e.parentElement;
                    t.classList.add("open");
                    const n = Array.from(t.querySelectorAll(".select__options li")).map((function(e) {
                            return e.offsetWidth
                        })),
                        o = Math.max.apply(0, n);
                    t.classList.remove("open"), t.style.minWidth = o + 1 + "px"
                }(e)
        }

        function n(e) {
            this.classList.toggle("open"), "LI" == e.target.tagName && function(e) {
                const t = e.target.closest(".select-wrapper"),
                    n = t.querySelector("select"),
                    o = t.querySelector(".select__selected"),
                    c = n.dataset.prefix ? `<span class="desktop-only">${n.dataset.prefix}: </span>` : "";
                n.value = e.target.dataset.val, o.innerHTML = c + (e.target.innerText || e.target.innerHTML), n.dispatchEvent(new Event("change"))
            }(e)
        }

        function o(e) {
            this.classList.remove("open")
        }
        return "loading" !== document.readyState ? e() : document.addEventListener("DOMContentLoaded", e), {
            wrap: e
        }
    }(),
    eventTracking = function() {
        let e = 0;

        function t() {
            if (void 0 !== window.dataLayer) switch (document.addEventListener("click", n), document.addEventListener("submit", o), pageData.pageType) {
                case "collection":
                    window.dataLayer.push({
                        event: "ecomListImpression",
                        ecommerce: {
                            currencyCode: "USD",
                            impressions: pageData.items
                        }
                    });
                    break;
                case "product":
                    window.dataLayer.push({
                        detailViewType: "product detail",
                        event: "ecomDetail",
                        ecommerce: {
                            currencyCode: "USD",
                            detail: {
                                actionField: {
                                    list: pageData.items[0].category
                                },
                                products: [pageData.items[0]]
                            }
                        }
                    });
                    break;
                case "checkout":
                    ! function() {
                        try {
                            switch (window.Shopify.Checkout.step) {
                                case "contact_information":
                                    s({
                                        step: 1
                                    });
                                    break;
                                case "shipping_method":
                                    s({
                                        step: 2
                                    });
                                    break;
                                case "payment_method":
                                    s({
                                        step: 3
                                    });
                                    break;
                                case "thank_you":
                                    i()
                            }
                        } catch (e) {
                            console.log(e)
                        }
                    }()
            }
        }

        function n(t) {
            t.target.closest(".quick-view") ? (function(t) {
                const n = Array.from(document.querySelectorAll(".product-card")),
                    o = t.target.closest(".product-card");
                e = n.indexOf(o)
            }(t), function(t) {
                const n = "" + document.querySelector(".collection-banner h1").innerText;
                pageData.items[e].position = e, window.dataLayer.push({
                    event: "ecomListClick",
                    ecommerce: {
                        currencyCode: "USD",
                        click: {
                            actionField: {
                                list: n
                            },
                            products: [pageData.items[e]]
                        }
                    }
                })
            }()) : t.target.closest(".add-to-cart") ? r(t) : t.target.closest(".remove-from-cart") ? a(t) : t.target.classList.contains("login-button") ? c("login", "user account", "login", "login: success") : t.target.classList.contains("registration-button") && c("registrationButton", "user account", "registration", "registration button")
        }

        function o(e) {
            "create_customer" === e.target.id && c("registrationSuccess", "user account", "registration", "registration: success")
        }

        function c(e, t, n, o) {
            window.dataLayer.push({
                event: e,
                eventCategory: t,
                eventAction: n,
                eventLabel: o
            })
        }

        function r(t) {
            const n = pageData.items[e];
            n.quantity = 1, window.dataLayer.push({
                event: "ecomAdd",
                ecommerce: {
                    currencyCode: "USD",
                    add: {
                        products: [n]
                    }
                }
            })
        }

        function a(e) {
            const t = new URLSearchParams(new URL(removeLink.href).search),
                n = parseInt(t.get("line")) - 1,
                o = pageData.items[n];
            window.dataLayer.push({
                event: "ecomRemove",
                ecommerce: {
                    remove: {
                        products: [o]
                    }
                }
            })
        }

        function s(e) {
            window.dataLayer.push({
                checkoutType: pageData.checkoutType,
                event: "ecomCheckout",
                ecommerce: {
                    currencyCode: "USD",
                    checkout: {
                        actionField: e,
                        products: pageData.items
                    }
                }
            })
        }

        function i() {
            window.dataLayer.push({
                event: "ecomPurchase",
                ecommerce: {
                    currencyCode: "USD",
                    purchase: {
                        actionField: window.purchaseObject,
                        products: pageData.items
                    }
                }
            })
        }
        return "loading" !== document.readyState ? t() : document.addEventListener("DOMContentLoaded", t), {
            start: t,
            addProduct: r,
            removeProduct: a,
            makePurchase: i,
            push: c
        }
    }();
! function() {
    let e = window.location.hostname;

    function t() {
        const t = document.querySelectorAll('a[href^="http"]');
        for (let n = 0, o = t.length; n < o; n++) {
            const o = t[n],
                c = new URL(o.href),
                r = o.target;
            (!c.hostname.includes(e) && "_blank" !== r || !e.includes(c.hostname) && "_blank" !== r) && (o.setAttribute("target", "_blank"), o.setAttribute("rel", "noreferrer noopener"))
        }
    }
    "loading" !== document.readyState ? t() : document.addEventListener("DOMContentLoaded", t)
}();
const lazyload = function() {
        let e = !1,
            t = !1,
            n = !1;

        function o() {
            const o = document.querySelectorAll("[data-src]"),
                s = document.querySelectorAll("[data-srcset]"),
                i = document.querySelectorAll("[data-bg]");
            o.length && (e = setInterval(c, 250)), s.length && (t = setInterval(r, 250)), i.length && (n = setInterval(a, 250))
        }

        function c() {
            const t = window.innerHeight + window.innerHeight / 4,
                n = document.querySelectorAll("[data-src]");
            for (let e = 0, o = n.length; e < o; e++) {
                const o = n[e],
                    c = o.getBoundingClientRect();
                if (c.top < t && c.bottom >= 0) {
                    const e = o.dataset.src;
                    o.src = e, o.removeAttribute("data-src")
                }
            }
            n.length || (clearInterval(e), e = !1)
        }

        function r() {
            const e = window.innerHeight + window.innerHeight / 4,
                n = document.querySelectorAll("[data-srcset]");
            for (let t = 0, o = n.length; t < o; t++) {
                const o = n[t],
                    c = o.getBoundingClientRect();
                if (c.top < e && c.bottom >= 0) {
                    const e = o.getAttribute("data-srcset");
                    o.setAttribute("srcset", e), o.removeAttribute("data-srcset")
                }
            }
            n.length || (clearInterval(t), t = !1)
        }

        function a() {
            const e = window.innerHeight + window.innerHeight / 4,
                t = document.querySelectorAll("[data-bg]");
            for (let n = 0, o = t.length; n < o; n++) {
                const o = t[n],
                    c = o.getBoundingClientRect();
                if (c.top < e && c.bottom >= 0) {
                    let e = o.dataset.bg;
                    o.style.backgroundImage = "url(" + e + ")", o.removeAttribute("data-bg")
                }
            }
            t.length || (clearInterval(n), n = !1)
        }
        return "loading" !== document.readyState ? o() : document.addEventListener("DOMContentLoaded", o), {
            start: o
        }
    }(),
    login = function() {
        let e, t, n, o = !1;

        function c() {
            o = document.querySelector(".template-login"), o && (e = document.querySelector("[data-login-form]"), t = document.querySelector("[data-recover-form]"), n = document.querySelector("[data-recover-toggle]"), r(), window.addEventListener("hashchange", r), n.addEventListener("click", a))
        }

        function r() {
            const e = window.location.hash;
            s(!(!e || "#recover" !== e))
        }

        function a(e) {
            window.location.hash = ""
        }

        function s(n) {
            n ? (e.classList.add("hide"), t.classList.remove("hide")) : (e.classList.remove("hide"), t.classList.add("hide"))
        }
        return "loading" !== document.readyState ? c() : document.addEventListener("DOMContentLoaded", c), {
            start: c
        }
    }(),
    miniCart = function() {
        let e, t, n, o, c, r, a, s, i;

        function l() {
            r = document.querySelector(".header"), c = document.querySelector(".container"), e = document.querySelector(".mini-cart"), e && (s = document.querySelectorAll(".add-to-cart"), t = e.querySelector(".mini-cart__close"), n = document.querySelector(".mini-cart__bg"), o = document.querySelectorAll('a[href="/cart"]'), function() {
                for (let e = 0, t = o.length; e < t; e++) o[e].addEventListener("click", p);
                if (s)
                    for (let e = 0, t = s.length; e < t; e++) s[e].addEventListener("click", u);
                e.addEventListener("click", h), t.addEventListener("click", g), n.addEventListener("click", g), window.addEventListener("resize", d), d()
            }())
        }

        function d() {
            a = window.innerWidth < 1024
        }

        function u(e) {
            e.preventDefault(), e.target.disabled = !0,
                function(e, t, n) {
                    document.querySelector(".error").classList.remove("on"), document.querySelector(".error").innerHTML = "";
                    const o = new XMLHttpRequest;
                    o.open("POST", "/cart/add.js", !0), o.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), o.onload = function() {
                        if (this.status >= 200 && this.status < 400) try {
                            m(n)
                        } catch (e) {
                            ! function(e) {
                                document.querySelector(".error").classList.add("on"), document.querySelector(".error").innerHTML = e
                            }(e), n.disabled = !1
                        } else n.disabled = !1
                    }, o.send(`id=${e}&quantity=${t}`)
                }(document.querySelector(".variant-select") ? document.querySelector(".variant-select").value : document.querySelector('input[name="id"]').value, document.querySelector('input[name="quantity"]') ? document.querySelector('input[name="quantity"]').value : 1, e.target)
        }

        function m(n) {
            const o = new XMLHttpRequest;
            o.open("GET", "/cart", !0), o.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8"), o.onload = function() {
                if (this.status >= 200 && this.status < 400) try {
                    ! function(n, o) {
                        const c = document.createElement("div");
                        c.innerHTML = n;
                        const r = e.querySelector(".cart-empty");
                        r ? function(n, o, c) {
                            const r = e.querySelector(".cart-wrapper"),
                                a = e.querySelector(".mini-cart__title");
                            r.innerHTML = `<div class="mini-cart__title">${a.innerHTML}</div><form data-count="1" action="/cart" method="post" class="cart-form" novalidate=""></form>`, c.remove();
                            const s = n.querySelector(".cart-form"),
                                i = e.querySelector(".cart-form");
                            i.innerHTML = s.innerHTML,
                                function(e) {
                                    const t = e.querySelector(".additional-checkout-buttons");
                                    t && t.remove();
                                    const n = e.querySelector(".cart-help");
                                    n && n.remove();
                                    e.querySelector('input[name="update"]').remove(), e.querySelector(".cart-total").classList.remove("cart-total--cart")
                                }(i);
                            const l = document.createElement("button");
                            l.classList.add("btn--secondary"), l.innerText = "View Bag", i.querySelector('input[name="checkout"]').insertAdjacentElement("afterend", l), t = e.querySelector(".mini-cart__close"), t.addEventListener("click", g), void 0 !== discounts && discounts.load();
                            f(o)
                        }(c, o, r) : function(t, n) {
                            void 0 !== discounts && discounts.refresh();
                            const o = t.querySelector(".cart-form");
                            e.querySelector(".cart-form").dataset.count = o.dataset.count;
                            const c = t.querySelector(".cart-items");
                            e.querySelector(".cart-items").innerHTML = c.innerHTML;
                            const r = t.querySelector(".cart-subtotal--price");
                            e.querySelector(".cart-subtotal--price").innerHTML = r.innerHTML, void 0 !== maxQTY && maxQTY.reload();
                            f(n)
                        }(c, o)
                    }(this.response, n)
                } catch (e) {
                    console.log(e), n.disabled = !1
                }
            }, o.send()
        }

        function f(t) {
            const n = document.querySelector(".cart-count"),
                o = parseInt(e.querySelector(".cart-form").dataset.count);
            n.innerHTML = `(${o})`, p(), void 0 !== modal && modal.isOpen() && modal.close(), t.disabled = !1, i = setTimeout(g, 1e4)
        }

        function p(t) {
            t && t.preventDefault(), e.classList.toggle("on"), n.classList.toggle("on"), a && c.classList.add("fixed")
        }

        function g() {
            e.classList.remove("on"), n.classList.remove("on"), c.classList.remove("fixed")
        }

        function h() {
            i && (clearTimeout(i), i = !1)
        }
        return "loading" !== document.readyState ? l() : document.addEventListener("DOMContentLoaded", l), {
            reset: l,
            refresh: m,
            show: p
        }
    }(),
    modal = function() {
        let e, t, n, o, c, r, a, s = !1;

        function i() {
            c = document.querySelector(".container"), e = document.querySelector(".modal"), t = e.querySelector(".modal__wrapper"), n = e.querySelector(".modal__close"), o = e.querySelector(".modal__content"), document.addEventListener("click", u), window.addEventListener("resize", l)
        }

        function l() {
            clearTimeout(a), a = setTimeout((function() {
                d()
            }), 250)
        }

        function d() {
            if (s) {
                const e = o.querySelector("#modal-youtube"),
                    t = {
                        width: 560,
                        height: 315
                    },
                    c = n.offsetHeight + 5,
                    r = (.8 * window.innerHeight - c) / t.height;
                e.height = Math.round(t.height * r), e.width = Math.round(t.width * r)
            }
        }

        function u(e) {
            (e.target.classList.contains("modal") || e.target.closest(".modal__close")) && f()
        }

        function m(n, a, s, i) {
            r = !0;
            const l = document.createElement("div");
            l.innerHTML = n, o.innerHTML = a ? l.querySelector("#content").innerHTML : l.innerHTML, s && (t.style.maxWidth = s + "px"), e.classList.add("on"), c.classList.add("blur"),
                function() {
                    void 0 !== quantities && quantities.wrap();
                    void 0 !== dropdown && dropdown.wrap()
                }(), i && i()
        }

        function f() {
            e.classList.remove("on"), c.classList.remove("blur"), o.innerHTML = "", t.style = null, r = !1, s = !1
        }
        return {
            loadContent: function(e, t, n, o) {
                i(),
                    function(e, t, n, o) {
                        const c = new XMLHttpRequest;
                        c.open("GET", e), c.onload = function() {
                            c.status >= 200 && c.status < 300 && m(c.response, t, n, o)
                        }, c.send()
                    }(e, t, n, o)
            },
            loadHTML: function(e, t, n) {
                i(), m(e, !1, t, n)
            },
            loadYouTube: function(e) {
                s = !0, i(), m(`<iframe id="modal-youtube" width="560" height="315" src="https://www.youtube.com/embed/${e}?rel=0&modestbranding=1&autohide=1&showinfo=0&controls=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`, !1, !1, d)
            },
            noClose: function() {
                n.remove(), document.removeEventListener("click", u)
            },
            isOpen: function() {
                return r
            },
            close: f
        }
    }(),
    navigation = function() {
        let e, t, n, o, c, r, a, s, i, l, d, u, m;

        function f() {
            m = document.querySelectorAll(".template-index").length, n = document.querySelector("header"), n && (o = document.querySelector("main"), c = document.querySelector("header.sticky"), r = n.querySelector(".nav"), a = n.querySelector(".nav-trigger"), s = n.querySelectorAll(".nav-close, .nav-bg"), i = n.querySelector(".nav-search"), l = n.querySelector(".header-search"), d = n.querySelectorAll("li.has-children > a"), u = n.querySelectorAll("li.back > a"), function() {
                a && a.addEventListener("click", y);
                for (let e = 0, t = s.length; e < t; e++) s[e].addEventListener("click", y);
                for (let e = 0, t = d.length; e < t; e++) d[e].addEventListener("click", L);
                for (let e = 0, t = u.length; e < t; e++) u[e].addEventListener("click", S);
                i && g(i);
                l && g(l);
                window.addEventListener("resize", p), p()
            }(), c && function() {
                const e = document.querySelector(".announcement-bar");
                window.onscroll = function() {
                    ! function(e) {
                        const t = e ? e.offsetHeight : 0,
                            r = c.classList.contains("stuck");
                        window.pageYOffset > t ? c.classList.add("stuck") : c.classList.remove("stuck");
                        const a = c.classList.contains("stuck");
                        r !== a && function(e, t) {
                            e ? (c.style.top = `-${t}px`, o.style.marginTop = n.offsetHeight + "px") : c.style.top = o.style.marginTop = "0"
                        }(a, t)
                    }(e)
                }
            }())
        }

        function p() {
            clearTimeout(e), e = setTimeout((function() {
                t = window.innerWidth < 1024, r && (v(!0), r.classList.remove("active"), a.classList.remove("active"), document.querySelector("html").classList.remove("locked"))
            }), 100)
        }

        function g(e) {
            const t = e.querySelector("input"),
                n = e.querySelector(".icon");
            e.addEventListener("keyup", (function(e) {
                13 === event.keyCode && h(t)
            })), n.addEventListener("click", (function(e) {
                h(t)
            }))
        }

        function h(e) {
            e.value.length ? window.location = "/search?q=" + e.value + "&type=product" : t && !r.classList.contains("active") && y()
        }

        function y(e) {
            v(r.classList.contains("active")), r.classList.toggle("active"), a.classList.toggle("active"), document.querySelector("html").classList.toggle("locked")
        }

        function v(e) {
            const o = n.offsetTop + n.offsetHeight;
            r.style.height = t && !e ? window.innerHeight - o + 15 + "px" : null
        }

        function L(e) {
            if (t) {
                e.preventDefault();
                const t = e.target.parentElement,
                    n = t.classList.contains("expand-all"),
                    o = t.querySelector("ul");
                if (o && (t.classList.toggle("active"), o.classList.toggle("active"), n)) {
                    const e = t.querySelectorAll(".nav-item--child.has-children");
                    for (let t = 0, n = e.length; t < n; t++) {
                        const n = e[t],
                            o = n.querySelector("ul");
                        n.classList.toggle("active"), o.classList.toggle("active")
                    }
                }
            }
        }
        function S(e) {
            if (t) {
                e.preventDefault();
                const t = e.target.closest("ul");
                t && t.classList.remove("active")
            }
        }
        return "loading" !== document.readyState ? f() : document.addEventListener("DOMContentLoaded", f), {}
    }();
! function() {
    let e, t, n, o, c = 1,
        r = 1,
        a = !1,
        s = !1;

    function i(c = !1) {
        e = document.querySelector(".pagination"), o = document.querySelector(".paginated"), e && o && (t = e.querySelector(".next-page"), n = t.querySelector("button"), t.addEventListener("click", p), c && "function" == typeof c && c())
    }

    function l() {
        e && o && (window.addEventListener("beforeunload", u), window.location.hash && window.location.hash.includes("page") && function() {
            c = parseInt(window.location.hash.split("=")[1]);
            const e = t.href.split("=")[0];
            t.href = `${e}=${c+1}`,
                function() {
                    const e = d();
                    sessionStorage.getItem(e) ? (o.innerHTML = sessionStorage.getItem(e), setTimeout((function() {
                        window.scrollTo({
                            top: parseFloat(sessionStorage.getItem("scrollPosition"))
                        })
                    }), 500), i()) : (s = setInterval(f, 500), a = setInterval(m, 100))
                }()
        }())
    }

    function d() {
        return `${document.location.pathname}${window.location.hash}`
    }

    function u() {
        ! function() {
            const e = Object.keys(sessionStorage);
            if (e)
                for (let t = 0, n = e.length; t < n; t++) e[t].includes(document.location.pathname) && sessionStorage.removeItem(e[t])
        }(), sessionStorage.setItem(d(), o.innerHTML), sessionStorage.setItem("scrollPosition", window.pageYOffset.toString())
    }

    function m() {
        window.scrollTo({
            top: document.body.scrollHeight,
            behavior: "smooth"
        })
    }

    function f() {
        r < c ? (r++, p()) : (clearInterval(s), s = !1, setTimeout((function() {
            clearInterval(a), a = !1
        }), 100))
    }

    function p(o) {
        o && (o.preventDefault(), c++, history.pushState({
                page: c
            }, "", "#page=" + c)),
            function(o) {
                if (o) {
                    n.disabled = !0;
                    const c = new XMLHttpRequest;
                    c.open("GET", o, !0), c.onload = function() {
                        this.status >= 200 && this.status < 400 && function(o) {
                            const c = document.createElement("html");
                            c.innerHTML = o;
                            const r = c.querySelectorAll(".product-card, .article-card");
                            for (let t = 0, n = r.length; t < n; t++) e.parentNode.insertBefore(r[t], e);
                            (function(o) {
                                const c = o.querySelector(".next-page");
                                c ? (t.href = c.href, n.disabled = !1) : e.remove()
                            })(c), lazyload.start()
                        }(this.response)
                    }, c.send()
                }
            }(t.href)
    }
    "loading" !== document.readyState ? i(l) : document.addEventListener("DOMContentLoaded", i(l))
}();
const parallax = function() {
    let e, t, n, o = !1;

    function c() {
        t = document.querySelectorAll("[data-animate]"), t.length && (e = setInterval(r, 250)), n = document.querySelectorAll("video[data-parallax]"), n.length && (o = setInterval(a, 250))
    }

    function r() {
        for (let e = 0, n = t.length; e < n; e++) {
            const n = t[e],
                o = n.dataset.animate;
            if (s(n)) {
                const e = n.dataset.delay;
                n.classList.contains(o) || (e ? setTimeout((function() {
                    n.classList.add(o)
                }), 1e3 * e) : n.classList.add(o))
            }
        }
    }

    function a() {
        for (let e = 0, t = n.length; e < t; e++) {
            const t = n[e];
            s(t) && (t.removeAttribute("data-parallax"), this.play())
        }
    }

    function s(e) {
        const t = !!e && e.getBoundingClientRect();
        return (t.height > 0 || t.width > 0) && t.bottom >= 0 && t.right >= 0 && t.top <= (window.innerHeight || document.documentElement.clientHeight) && t.left <= (window.innerWidth || document.documentElement.clientWidth)
    }
    return "loading" !== document.readyState ? c() : document.addEventListener("DOMContentLoaded", c), {
        start: c
    }
}();
! function() {
    if ("function" == typeof window.CustomEvent) return !1;

    function e(e, t) {
        t = t || {
            bubbles: !1,
            cancelable: !1,
            detail: void 0
        };
        const n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n
    }
    e.prototype = window.Event.prototype, window.CustomEvent = e
}();
const crosssell = function() {
        let e, t, n, o, c, r;
        function a() {
            if (e = document.querySelector(".cross-sells"), e) {
                t = document.querySelector("h1").dataset.title, o = e.dataset.label || "", n = e.dataset.titleseparator || "", c = e.dataset.separator || "", r = "true" === e.dataset.show_soldout;
                try {
                    ! function() {
                        const a = `${t.split(c)[0]} ${c}`,
                            i = new XMLHttpRequest,
                            l = `/search?type=product&q="${a}"&view=json`;
                        i.open("GET", l, !0), i.onload = function() {
                            this.status >= 200 && this.status < 400 && function(c) {
                                if (c.results.length) {
                                    const a = t.split(n)[1] ? t.split(n)[1].toLowerCase() : "";
                                    let i = `<label>${o} ${a}</label><div class="product-crosssells">`;
                                    for (let e = 0, t = c.results.length; e < t; e++)(r || c.results[e].available) && (i += s(c.results[e]));
                                    i += "</div>", e.innerHTML = i
                                }
                            }(JSON.parse(this.response))
                        }, i.send()
                    }()
                } catch (e) {
                    console.log(e)
                }
            }
        }

        function s(e) {
            const n = e.title === t ? "selected" : "",
                o = e.title.split(c)[1] || e.title;
            return `<a href="${e.url}" title="${o}" data-available="${e.available}">\n                    <img class="product-crosssell ${n}" src="${e.thumbnail}"/>\n                </a>`
        }
        return "loading" !== document.readyState ? a() : document.addEventListener("DOMContentLoaded", a), {
            render: a
        }
    }(),
    product = function() {
        let e, t, n, o, c, r, a, s, i, l = !1;

        function d() {
            e = document.querySelector(".product-detail"), e && (s = document.querySelector(".product-image__zoom"), t = document.querySelector(".product-image"), n = document.querySelector(".variant-select"), i = document.querySelector(".add-to-cart"), o = document.querySelectorAll(".option-chooser"), c = document.querySelectorAll(".product-option"), r = document.querySelectorAll(".product-tab"), a = document.querySelectorAll("[data-tab]"), document.addEventListener("click", u), function() {
                if (n) {
                    if (n.addEventListener("change", y), o.length)
                        for (let e = 0, t = o.length; e < t; e++) {
                            o[e].addEventListener("change", f);
                            const t = new Event("change");
                            o[e].dispatchEvent(t)
                        }
                    if (c.length) {
                        let e = !1;
                        for (let t = 0, n = c.length; t < n; t++) c[t].addEventListener("click", m), c[t].classList.contains("selected") && (e = t);
                        e && c[e].click();
                    }
                }
                if (r.length)
                    for (let e = 0, t = r.length; e < t; e++) r[e].addEventListener("click", L);
                s && (p(t.querySelector(".active")), s.addEventListener("click", g))
            }())
        }

        function u(e) {
            if (e.target.closest(".product-thumb")) {
                const t = e.target.dataset.id;
                ! function(e) {
                    const t = document.querySelectorAll(".product-thumb");
                    for (let e = 0, n = t.length; e < n; e++) t[e].classList.remove("active");
                    e.classList.add("active")
                }(e.target.closest(".product-thumb")), v(t)
            }
        }

        function m(e) {
            if (!e.target.classList.contains("disabled")) {
                e.target.querySelector("input").checked = !0;
                const t = e.target.parentElement.querySelectorAll(".product-option");
                for (let n = 0, o = t.length; n < o; n++) t[n] !== e.target ? t[n].classList.remove("selected") : t[n].classList.add("selected");
                f(e)
            }
        }

        function f(e) {
            try {
                const t = e.target.classList.contains("flat");
                let swatch_count = parseInt(e.target.getAttribute('data-variant-inventory-count'));
                let c = e.target;
                if (t || (c = document.querySelector("" + function() {
                        let e = "";
                        for (let t = 0, n = o.length; t < n; t++) {
                            const n = o[t];
                            n.id ? e += `[data-${n.id}="${n.value}"]` : n.checked && (e += `[data-${n.parentElement.id}="${n.value}"]`)
                        }
                        return e
                    }())), c.value || (c.value = c.querySelector(".selected input").value), c.dataset.title) {
                    const e = document.querySelector(".selected-option");
                    e && (e.innerHTML = c.dataset.title)
                }
                n.value = c.value, y(n), !0 === c.disabled ? (i.disabled = !0, i.innerHTML = `<span data-submit-button-text>${i.dataset.sold_out}</span>`) : (i.disabled = !1, i.innerHTML = `<span data-submit-button-text>${i.dataset.available}</span>`);
                let marquee = document.querySelector('.lrg-marquee');
                let msg = '';
                if (swatch_count > 0) { 
                marquee.hidden = false;
                } else {
                // sold out / no stock — hide and stop here
                marquee.hidden = true;
                return;
                }
                msg = 'Only ' + swatch_count + ' left in stock';
                // update the three attributes
                marquee.style.setProperty('--lrg-msg', "'" + msg + "'");
                marquee.setAttribute('role', 'status');
                marquee.setAttribute('aria-label', msg);
                
            } catch (e) {
                console.log(e)
            }
        }

        function p(e) {
            try {
                l && g();
                const t = e.querySelector("img").src;
                s.style.backgroundImage = `url(${t})`
            } catch (e) {
                console.log(e)
            }
        }

        function g() {
            s.classList.toggle("on"), l = s.classList.contains("on"), l ? s.addEventListener("mousemove", h) : s.removeEventListener("mousemove", h)
        }

        function h(e) {
            const t = this.getBoundingClientRect(),
                n = e.clientX - t.left,
                o = e.clientY - t.top,
                c = Math.round(100 / (t.width / n)),
                r = Math.round(100 / (t.height / o));
            this.style.backgroundPosition = `${c}% ${r}%`
        }

        function y(e) {
            const t = e.target ? e.target.options[e.target.selectedIndex].dataset.image : e.options[e.selectedIndex].dataset.image;
            t && v(t)
        }

        function v(e) {
            const t = document.querySelectorAll(".product-image .image-wrapper");
            for (let n = 0, o = t.length; n < o; n++) {
                t[n].dataset.id === e ? (t[n].classList.add("active"), s && p(t[n])) : t[n].classList.remove("active")
            }
        }

        function L(e) {
            const t = e.target.classList.contains("product-tab") ? e.target : e.target.closest(".product-tab");
            for (let e = 0, n = a.length; e < n; e++) a[e].dataset.tab === t.dataset.tab ? a[e].classList.add("active") : a[e].classList.remove("active")
        }
        return "loading" !== document.readyState ? d() : document.addEventListener("DOMContentLoaded", d), {
            start: d
        }
    }(),
    quantities = function() {
        function e() {
            const e = document.querySelectorAll('input[type="number"]');
            for (let n = 0, o = e.length; n < o; n++) {
                const o = e[n];
                o.closest(".number_wrapper") || t(o)
            }
        }

        function t(e) {
            const t = document.createElement("span");
            t.classList.add("number_wrapper"), e.parentNode.insertBefore(t, e);
            const o = document.createElement("span");
            o.classList.add("num", "down"), o.innerHTML = "-", t.appendChild(o), t.appendChild(e);
            const r = document.createElement("span");
            r.classList.add("num", "up"), r.innerHTML = "+", t.appendChild(r), c(e), e.addEventListener("change", c), e.parentNode.addEventListener("click", n)
        }

        function n(e) {
            e.target.classList.contains("num") && (e.target.classList.contains("down") ? o(e.target, "down") : o(e.target, "up"))
        }

        function o(e, t) {
            try {
                const n = e.parentElement.querySelector("input");
                "up" === t ? n.value = parseInt(n.value) + 1 : parseInt(n.value) - 1 > 0 && (n.value = parseInt(n.value) - 1), c(n)
            } catch {}
        }

        function c(e) {
            const t = e.target ? e.target : e,
                n = parseInt(t.value),
                o = !!t.dataset.maxqty && parseInt(t.dataset.maxqty);
            if (o && n >= o) {
                t.value = o;
                try {
                    ! function(e) {
                        e.closest(".cart-items__row") ? e.closest(".cart-items__row").querySelector(".error--qty").classList.add("on") : e.parentNode.parentNode.querySelector(".error--qty") && e.parentNode.parentNode.querySelector(".error--qty").classList.add("on")
                    }(t)
                } catch (e) {}
            }
        }
        return "loading" !== document.readyState ? e() : document.addEventListener("DOMContentLoaded", e), {
            wrap: e
        }
    }(),
    quickView = function() {
        function e() {
            document.querySelectorAll(".quick-view").length && document.addEventListener("click", t)
        }

        function t(e) {
            e.target.parentElement.classList.contains("quick-view") && (e.preventDefault(), e.target.disabled = !0, function(e, t) {
                const n = new XMLHttpRequest;
                n.open("GET", e), n.onload = function() {
                    if (n.status >= 200 && n.status < 300) try {
                        ! function(e, t) {
                            const n = document.createElement("div");
                            n.innerHTML = e, n.querySelector(".product-description").remove();
                            const o = n.querySelector(".shopify-product-form"),
                                c = `<a class="view-details" href="${t}">\n                                <button class="btn--secondary">View Full Details</button>\n                             </a>`;
                            o.insertAdjacentHTML("afterend", c);
                            const r = n.querySelector(".product-detail");
                            modal.loadHTML(r.outerHTML, 850, quickView.productLoaded)

                            const product_options = [...document.querySelectorAll('[data-product-option]')];

                            product_options.forEach((option) => {
                              option.addEventListener('click', (e) => {
                                const { target } = e;
                                const input = target.querySelector('input');
                                const add_to_cart_button = document.querySelector('[data-submit-button]');
                                if (input.disabled) {
                                    add_to_cart_button.disabled = true;
                                    add_to_cart_button.textContent = "UNAVAILABLE";
                                } else {
                                    add_to_cart_button.disabled = false;;
                                    add_to_cart_button.textContent = "ADD TO CART";
                                }
                              });
                            });
                        }(n.response, e), t.disabled = !1
                    } catch (e) {
                        console.log(e)
                    }
                }, n.send()
            }(e.target.parentElement.dataset.url, e.target))
        }
        return "loading" !== document.readyState ? e() : document.addEventListener("DOMContentLoaded", e), {
            start: e,
            productLoaded: function() {
                product.start(), miniCart.reset()
            }
        }
    }(),
    recentProducts = function() {
        let e, t, n;

        function o() {
            window.location.href.indexOf("/products/") >= 0 && (t = document.querySelector('[class^="recents-grid"]'), t && (n = t.dataset.limit, e = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1], function() {
                if (t) {
                    let o = 0;
                    const a = r(),
                        s = a.length;
                    for (let t = 0; t < s; t++) a[t] !== e && o < n && (c(a[t]), o++);
                    o > 0 && t.parentNode.classList.add("on")
                }! function() {
                    const t = r(),
                        o = t.indexOf(e);
                    o < 0 ? function(t) {
                        t.unshift(e), a(t = t.splice(0, n + 1))
                    }(t) : function(t, n) {
                        t.splice(n, 1), t.unshift(e), a(t)
                    }(t, o)
                }()
            }()))
        }

        function c(e) {
            const n = new XMLHttpRequest;
            n.open("GET", `/products/${e}.json`, !0), n.onload = function() {
                this.status >= 200 && this.status < 400 && function(e) {
                    try {
                        const n = e.product,
                            o = n.title.split(" - ")[0],
                            c = n.variants[0],
                            r = parseFloat(c.price) < parseFloat(c.compare_at_price) ? `<span class="visually-hidden">Regular price</span><s>$${c.compare_at_price}</s> <span class="price--discount">$${c.price}</span>` : `<span>$${c.price}</span>`,
                            a = document.createElement("div");
                        a.classList.add("product-card"), a.innerHTML = `<a href="/products/${n.handle}">\n                    <picture class="image-wrapper ">\n                        <img src="${n.image.src}" alt="${n.title}">\n                    </picture>\n                    <h4>${o}</h4>\n                    <h5>${r}</h5>\n                </a>`, t.appendChild(a)
                    } catch (e) {
                        console.log(e)
                    }
                }(JSON.parse(this.response))
            }, n.send()
        }

        function r() {
            return JSON.parse(sessionStorage.getItem("recent_products")) || []
        }

        function a(e) {
            sessionStorage.setItem("recent_products", JSON.stringify(e))
        }
        return "loading" !== document.readyState ? o() : document.addEventListener("DOMContentLoaded", o), {
            start: o
        }
    }(),
    slider = function() {
        let e, t = [];

        function n() {
            e = document.querySelectorAll(".slide-wrapper"), e && function() {
                for (let n = 0, o = e.length; n < o; n++) {
                    const o = e[n];
                    r(o), s(o);
                    const a = o.dataset.auto,
                        i = o.dataset.timer;
                    "true" === a && (t[o] = setInterval((function() {
                        c(o)
                    }), 1e3 * i))
                }
                o(), window.addEventListener("resize", o)
            }()
        }

        function o() {
            for (let t = 0, n = e.length; t < n; t++) {
                const n = e[t].querySelector(".slider-indicator.active");
                n && n.click()
            }
        }

        function c(e) {
            const t = e.querySelectorAll(".slider-indicator"),
                {
                    currentSlide: n
                } = a(e.querySelector(".slider"));
            (t[n + 1] ? t[n + 1] : t[0]).click()
        }

        function r(e) {
            const t = e.querySelector(".slider");
            t && (t.onscroll = function() {
                ! function(e) {
                    const {
                        currentSlide: t
                    } = a(e);
                    ! function(e, t) {
                        try {
                            const n = e.parentElement.querySelector(".slider-indicator.active"),
                                o = t * e.dataset.layout,
                                c = e.parentElement.querySelector(`.slider-indicator[data-index="${o}"]`);
                            c && c.classList.add("active"), e.parentElement.querySelectorAll(".slider-indicator.active").length > 1 && n.classList.remove("active")
                        } catch (e) {
                            console.log(e)
                        }
                    }(e, t)
                }(t)
            })
        }

        function a(e) {
            const t = e.scrollLeft,
                n = parseInt(e.dataset.layout),
                o = e.querySelector(".slide").clientWidth;
            return {
                currentX: t,
                layout: n,
                width: o,
                currentSlide: Math.round(t / o) / n
            }
        }

        function s(e) {
            const t = e.querySelectorAll(".slider-indicator");
            if (t)
                for (let e = 0, n = t.length; e < n; e++) t[e].addEventListener("click", i)
        }

        function i(e) {
            if (!e.target.classList.contains("active") || e.x > 0) {
                ! function(e, t) {
                    const {
                        width: n
                    } = a(e);
                    e.scroll({
                        left: n * t,
                        behavior: "smooth"
                    })
                }(e.target.closest(".slide-wrapper").querySelector(".slider"), e.target.dataset.index)
            }
        }
        return "loading" !== document.readyState ? n() : document.addEventListener("DOMContentLoaded", n), {
            load: n
        }
    }();
